import { okrDetailConstants } from "../../constants/okr/okrDetails.constants";
import GoalServices from '../../services/goal.services';
import {
  applyHideEmptyOkrsToApiParams,
  buildFilterDataSet,
  getFilterParamsFromUrl,
  getOkrFilterCount,
} from '../../utils/okrFilterParams.util';

let services = new GoalServices();

export const filteredOKR = (rows, filterDataSet, count) => dispatch => dispatch({
	type: okrDetailConstants.FILTERED_DATA,
	rows: rows,
	filterDataSet: filterDataSet,
	count: count
});

const addNewKr = (item, teamId) => {
	return { type: okrDetailConstants.ADD_NEW_KR, item, teamId }
}

const deleteKr = (krId, goalId, teamId, userId) => {
	return { type: okrDetailConstants.DELETE_KR, krId, goalId, teamId, userId }
}

const setKeyResultsStatus = (metricIds, status) => ({
	type: okrDetailConstants.SET_KEY_RESULTS_STATUS, metricIds, status,
});

export const okrDetailActions = {
	getMyGoals,
	getMyGoalsFiltered,
	saveMyOkrFilters,
	fetchKrSourcePopupData,
	getFullAlignData,
	getTeamsOkr,
	getMyDirectsKR,
	getMyManagersOkr,
	getMyTeamsOkr,
	updateKRReactedEmoji,
	saveShortCutPreference,
	getDirectDottedSingleGoal,
	getSingleKrDetails,
	getOverduePersonKrs,
	getFilteredPersonKrs,
	updateDirectDottedKr,
	closeOutKr,
	updateCascadeKrList,
	updateCommentCount,
	getMetricesFiltered,
	addNewKr,
	deleteKr,
	setKeyResultsStatus
}

function getMyGoals(data) {
	return dispatch => {
		 if (data.offset == 0) {
			dispatch(resetTeamsData());
		 }
		 if(!data.overdueKR){
			delete data.overdueKR;
		}
		services.getMyGoals(data).then(response => {
			delete data.gs;
			let goalData = response.data || [];
			if (typeof data.overdueKR !== 'undefined' && data.offset == 0) {
				dispatch(updateduekrs(goalData));
			} else {
				dispatch(success(goalData));
			}
		})
	}

	function success(data) {
		return { type: okrDetailConstants.GET_GOAL_DETAILS_SUCCESS, data }
	}
	function updateduekrs(data) {
		return { type: okrDetailConstants.UPDATE_OVERDUE_KR_SUCCESS, data }
	}
	function resetTeamsData() {
		return { type: okrDetailConstants.RESET_GOAL_DATA }
	}
}

function getMyGoalsFiltered(data) {
    return dispatch => {
        dispatch(resetTeamsData());
        services.getMyGoals(data).then(response => {
            let goalData = response.data.goals || [];
			dispatch(success(goalData));
			dispatch(updatePreferences(data.f));
        })
    }

    function success(data) {
        return { type: okrDetailConstants.GET_MY_GOALS_FILTERED, data }
    }

    function resetTeamsData(){
        return {type: okrDetailConstants.RESET_GOAL_DATA}
	}
	function updatePreferences(data){
		return {type: okrDetailConstants.UPDATE_FILTER_PREFERENCES,data}
	}
}

function getMetricesFiltered(data) {
	return dispatch => {
			dispatch(resetTeamsData());
			services.getMyGoals(data).then(response => {
					let goalData = response.data.goals || [];
		dispatch(success(goalData));
		dispatch(updatePreferences(data.f));
			})
	}

	function success(data) {
			return { type: okrDetailConstants.GET_METRICES_FILTERED, data }
	}

	function resetTeamsData(){
			return {type: okrDetailConstants.RESET_GOAL_DATA}
	}

	function updatePreferences(data){
		return {type: okrDetailConstants.UPDATE_FILTER_PREFERENCES, data}
	}
}

function fetchKrSourcePopupData(data) {
	return dispatch => {
		dispatch(success(null, data, null)); // hoverData is null -> 'loading'
		services.getKrHoverData({ metricId: data.metricId })
		  .then(response => {
		    let hoverData = response.data.sourcePopupDetails || [];
		    const parentMetricId = response.data.parentMetricId || null;
		    const goalId = response.data.goalId || null;
		    if(typeof data.goalId == undefined || data.goalId == null) {
		      data.goalId = goalId;
		    }
		    dispatch(success(hoverData, data, parentMetricId));
		  })
		  .catch(() => {
		    dispatch(success([], data, null)); // hoverData is empty array -> 'no data'
		  });
	}

	function success(hoverData, keyIds, parentMetricId) {
		return {
			type: okrDetailConstants.GET_KR_SOURCE_POPUP_DATA,
			payload: {
				data: hoverData,
				Ids: keyIds,
        parentMetricId
			}
		}
	}
}

function getFullAlignData(params) {
	return dispatch => {
		services.getGoalAlignmentSearch(params)
			.then(function (response) {
				let resData = response.data || {};
				dispatch(success(resData));
			});
	}

	function success(data) {
		return {
			type: okrDetailConstants.GET_FULL_ALIGN_DATA,
			data
		}
	}
}

function getTeamsOkr(params) {
	return dispatch => {
		
		if( (typeof params.offset == 'undefined' || params.offset == 0)){
			dispatch(resetTeamsData());
		}
		if(!params.overdueKR){
			delete params.overdueKR;
		}
		services.getTeamsOkr(params)
			.then(function (response) {
				let resData = response.data || {};
				if(typeof params.offset == 'undefined' || params.offset == 0){
					dispatch(overdueSuccess(resData));
				}else{
					dispatch(success(resData));
				}
				
			});
	}

	function success(data) {
		return {
			type: okrDetailConstants.GET_TEAMS_OKR_SUCCESS,
			data
		}
	}
	function overdueSuccess(data){
		return {type:okrDetailConstants.OVERDUE_KEY_RESULTS_TEAM,data }
	}
	function resetTeamsData() {
		return { type: okrDetailConstants.RESET_GOAL_DATA }
	}
}

function getMyDirectsKR(params, options = {}) {
	return dispatch => {
		const apiParams = { ...params };
		if (typeof apiParams.offset == 'undefined' || apiParams.offset == 0) {
			dispatch(resetTeamsData());
		}
		if(typeof apiParams.overdueKR !== 'undefined' && !apiParams.overdueKR){
			delete apiParams.overdueKR;
		}
		if (options.uiFiltersApplied === true) {
			apiParams[okrDetailConstants.UI_FILTERS_APPLIED] = 1;
		} else {
			delete apiParams[okrDetailConstants.UI_FILTERS_APPLIED];
		}
		applyHideEmptyOkrsToApiParams(apiParams, {
			clientFilterApplied: options.clientFilterApplied === true,
			dueStatus: options.dueStatus === true,
			appliedListFilters: options.appliedListFilters === true,
		});

		let requestMeta = {};
		if (options.appliedListFilters === true || options.uiFiltersApplied === true) {
			requestMeta = {
				fromFilter: true,
				filterDataSet: options.filterDataSet || buildFilterDataSet(getFilterParamsFromUrl()),
				filterCount: options.filterCount ?? getOkrFilterCount(apiParams),
				clientFilterApplied: options.clientFilterApplied !== false,
				dueStatus: options.dueStatus === true,
			};
		}
		if (options.filterCount === 0) {
			requestMeta.filterCount = 0;
			requestMeta.clientFilterApplied = false;
		}

		return services.getMyDirectsKR(apiParams).then(function (response) {
			if (response.data) {
				let resData = response.data || {};
				dispatch(success(resData, requestMeta));
			} else {
				dispatch(failure());
			}
		})
	}
	function success(data, meta = {}) {
		return { type: okrDetailConstants.GET_DIRECT_DOTTED_KRS_SUCCESS, data, meta }
	}
	function failure() {
		return { type: okrDetailConstants.OKR_ERROR_HANDLING }
	}
	function resetTeamsData() {
		return { type: okrDetailConstants.RESET_GOAL_DATA }
	}
}

function getMyManagersOkr(data) {
	return dispatch => {
		if (data.offset == 0) {
			dispatch(resetTeamsData());
		}
		if(typeof data.overdueKR !== 'undefined' && !data.overdueKR){
			delete data.overdueKR;
		}
		services.getMyGoals(data).then(response => {
			delete data.gs;
			let goalData = response.data || [];
			if (typeof data.overdueKR !== 'undefined' && data.overdueKR && data.offset == 0) {
				dispatch(updateduekrs(goalData));
			} else {
				dispatch(success(goalData));
			}
		})
	}

	function success(data) {
		return { type: okrDetailConstants.GET_MY_MANAGER_OKR_SUCCESS, data }
	}
	function updateduekrs(data) {
		return { type: okrDetailConstants.UPDATE_OVERDUE_KR_SUCCESS, data }
	}
	function resetTeamsData() {
		return { type: okrDetailConstants.RESET_GOAL_DATA }
	}
}

function getMyTeamsOkr(data) {
	return dispatch => {
		if (data.offset == 0) {
			dispatch(resetTeamsData());
		}
		if(typeof data.overdueKR !== 'undefined' && !data.overdueKR){
			delete data.overdueKR;
		}
		services.getMyGoals(data).then(response => {
			delete data.gs;
			let goalData = response.data || [];
			if (typeof data.overdueKR !== 'undefined' && data.overdueKR && data.offset == 0) {
				dispatch(updateduekrs(goalData));
			} else {
				dispatch(success(goalData));
			}
		})
	}

	function success(data) {
		return { type: okrDetailConstants.GET_MY_TEAMS_OKR_SUCCESS, data }
	}
	function updateduekrs(data) {
		return { type: okrDetailConstants.UPDATE_OVERDUE_KR_SUCCESS, data }
	}
	function resetTeamsData() {
		return { type: okrDetailConstants.RESET_GOAL_DATA }
	}
}


function saveMyOkrFilters(params) {

}

function updateKRReactedEmoji(data) {
	return { type: okrDetailConstants.UPDATE_KR_REACTED_EMOJI, data }
}

function saveShortCutPreference(gId) {
	return dispatch => {
		let params = { goalId: gId };
		params.status = 0;
		let data = params;
		dispatch(success(data));
		services.SaveShortcutBarPreference(params).then(response => {
			if (response.data) {
			} else {
				params.status = 1;
				let data = params;
				dispatch(success(data));
			}
		}).catch((error) => {
			params.status = 1;
			let data = params;
			dispatch(success(data));
		})
	}

	function success(data) {
		return { type: okrDetailConstants.UPDATE_SHORT_CUT_BAR_SUCCESS, data }
	}
}

function getDirectDottedSingleGoal(params) {
	return dispatch => {
		params.depCount = true;
		services.getGoalData(params).then(response => {
			if (response.data) {
				response.data.actionType = params.actionType;
				dispatch(success(response.data));
			}
		})
	}

	function success(data) {
		return { type: okrDetailConstants.UPDATE_DIRECT_DOTTED_GOAL, data }
	}
}

function getSingleKrDetails(data) {
	return dispatch => {
		let params = { goalId: data.goalId,metricId: data.metricId}
		if(data.overDue){
			params.overdueKR = data.overDue
		}
		let krdata = data.metricId;
		services.getGoalData(params).then(response => {
			if (response.data) {
				if(response.data.goals.length > 0){

					let metricDetails = response.data.goals[0].goal_metrics.find(metric => (metric.id == data.metricId));
					if(metricDetails){
						dispatch(success(metricDetails));
					}else{
						dispatch(excludeKr(krdata));
					}
				}else{
					dispatch(excludeKr(krdata));
				}
				
				
			}
		})
	}

	function success(data) {
		return { type: okrDetailConstants.GET_SINGLE_KR_DETAILS, data }
	}

	function excludeKr(data){
		return {type: okrDetailConstants.EXCLUDE_KR_FROM_LIST,data}
	}
}

function updateDirectDottedKr(params){
	return dispatch => {
		services.getGoalData(params).then(response => {
			if (response.data) {
				let metricDetails = response.data.goals[0].goal_metrics.find(metric => (metric.id == params.metricId)
				);
				dispatch(success(metricDetails));
			}
		})
	}

	function success(data) {
		return { type: okrDetailConstants.UPDATE_DIRECT_DOTTED_KR, data }
	}
}

function getOverduePersonKrs(data) {
	return dispatch => {
		if (data.offset == 0) {
			dispatch(resetTeamsData());
		}
		
		if(!data.overdueKR){
			delete data.overdueKR;
		}
		services.getPersonKrLists(data).then(response => {
			if (response.data) {
				let resp = response.data;
				dispatch(success(resp));
			}
		})
	}

	function success(data) {
		return { type: okrDetailConstants.PERSON_DUE_KEY_RESULTS, data }
	}

	function resetTeamsData() {
		return { type: okrDetailConstants.RESET_GOAL_DATA }
	}
}

function getFilteredPersonKrs(params) {
	return dispatch => {
		if (params.offset == 0) {
			dispatch(resetTeamsData());
		}
		
		if(!params.overdueKR){
			delete data.overdueKR;
		}
		services.getPersonKrLists(params).then(response => {
			if (response.data) {
				let resp = response.data.data;
				dispatch(success(resp));
			}
		})
	}

	function success(data) {
		return { type: okrDetailConstants.UPDATE_PERSON_SEARCH_RESULT, data }
	}

	function resetTeamsData() {
		return { type: okrDetailConstants.RESET_GOAL_DATA }
	}
}

function closeOutKr(metricId) {
	return dispatch => {
		services.closeCascadeMetric({ metricId: metricId }).then(response => {
			dispatch(success(metricId));
		});
	}

	function success(metricId) {
		let data = {};
		data.id = metricId
		return { type: okrDetailConstants.DELETE_SINGLE_KR, data }
	}
}

function updateCascadeKrList(params){
	return dispatch=>{
		services.getGoalData(params).then(response => {
			if (response.data) {
				let metricDetails = response.data.goals[0].goal_metrics.find(metric => (metric.id == params.metricId));
				dispatch(success(metricDetails));
			}
		})
	}

	function success(data){
		return {type: okrDetailConstants.UPDATE_CASCADE_KR_LIST,data}
	}
}

function updateCommentCount (goalId, metricId, parentMetricId) {
	return dispatch=>{
		services.getMetricCommentCount({ metricId: metricId }).then(response => {
			if (response.data) {
				dispatch(success(response.data.count, metricId, goalId, parentMetricId));
			}
		})
	}

	function success(count, metricId, goalId){
		let params = {};
		params.goal_id = goalId;
		params.metric_id = metricId;
		params.parentMetricId = parentMetricId;
		params.actionType = 'update';
		params.commentCnt = count;
		return {type: okrDetailConstants.UPDATE_COMMENT_COUNT, params}
	}
}
